<template>
    <div class="xiangmu">
<!--        <breadcrumb :routerList="[{to:'/chanp/ProductHierarchy',title:'产品层级'}]"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 bianju">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
                        <el-form-item label="产品大类">
                            <brselect clearable category="product_level" :v="q.onelevelin" :showcode="true"
                                      v-model="q.onelevelin"></brselect>
                        </el-form-item>
						<el-form-item label="层级编码/描述">
						    <el-input v-model="q.idLike" placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="税码">
						    <el-input v-model="q.taxcodeLike" placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="所在层级">
						    <el-select v-model="q.fid" :clearable="true">
						        <el-option label="1" value="1"></el-option>
						        <el-option label="2" value="2"></el-option>
						        <el-option label="3" value="3"></el-option>
						        <el-option label="4" value="4"></el-option>
						    </el-select>
						</el-form-item>
                        <el-form-item label="状态">
                            <brselect clearable category="prolevelstatus" :v="q.field"
                                      v-model="q.field"></brselect>
                        </el-form-item>
                    </div>


                    <div class="h-formBtnOut h-columnCenter">

                        <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button
							class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
							@click="createdemand"
							>新增产品层级
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30 bianju">
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    type="index"
					max-height="500"
					border
            >
                <el-table-column
                        type="selection"
                        width="45"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="层级编码"
                        width="200"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="text-align: left;" v-html="$options.filters.showlevelblank(scope.row)"></div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="fid"
                        label="所在层级"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="levelname"
                        label="描述"
                        width="260"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="taxcode"
                        label="税码"
                        width="250"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope" >
                        <span v-if="scope.row.edittax == 1">
                          {{scope.row.taxcode}}
                        </span>
                        <el-input v-if="scope.row.edittax == 0" class="h-tableInput" v-model="scope.row.taxcode" placeholder="请填写" autocomplete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="spbmjc"
                    label="税描述"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="120"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="field"
                        label="状态"
                        width="100"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.refer=='1'">通过</div>
                        <div v-if="scope.row.refer=='0' && scope.row.field=='0'">暂存</div>
                        <div v-if="scope.row.refer=='0' && scope.row.field=='2'">审批中</div>
                        <div v-if="scope.row.refer=='0' && scope.row.field=='3'">驳回</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right"  width="170">
                    <template slot-scope="scope">
                        <el-button
                                v-if="scope.row.instid"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn">
                            <span  @click="showshenpi(scope.row.instid)">跟踪</span>
                        </el-button>
                        <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn">
                            <span v-if="(cjgly || scope.row.cucode == _user.usercode) && scope.row.refer == '1' && scope.row.edittax == 1 && scope.row.id.length<=6" @click="edittaxcode(scope.row,scope.$index)">编辑</span>
                            <span v-if="scope.row.edittax == 0" @click="updatetax(scope.row,scope.$index)">提交</span>
                        </el-button>

                        <el-button
                                v-if="scope.row.edittax == '0'"
                                @click="cancelRow(scope.row,scope.$index)"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                        >取消
                        </el-button>
                        <el-button
                                v-if="(cjgly || scope.row.cucode == _user.usercode) && scope.row.field=='0'"
                                @click="editlevel(scope.row)"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn">
                            编辑
                        </el-button>
                        <el-button
                                v-if="(cjgly || scope.row.cucode == _user.usercode) && scope.row.edittax == '1'"
                                @click="deleteIndex(scope.row,scope.$index)"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn">
                            删除
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="proLevelImportExcel"
                                     :startrow="3" @callback="uploadExcelFilecallback"/>-->
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <el-dialog :visible.sync="dialogFormVisible1" class="h-dialog2" @close="cancelPro('f')">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新增产品层级</h1>
                        <p>New Product Level</p>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div>
                    <el-form :model="f" label-position=right ref="f" :inline="true"
                             class="demo-ruleForm h-formbLine tan" :rules="rules">
                        <el-form-item label="所在层级" class="h-elformWrap-1" prop="fid">
                            <el-select v-model="f.fid" style="width:300px" @change="selectByFid">
                                <el-option label="1" value="1"></el-option>
                                <el-option label="2" value="2"></el-option>
                                <el-option label="3" value="3"></el-option>
                                <el-option label="4" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <br>
                        <el-form-item label="上一级" class="h-elformWrap-1" v-if="f.fid==1">
                            <el-input value="无" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="上一级" class="h-elformWrap-1" v-else prop="sid">
                            <el-select v-model="f.sid" style="width:300px" filterable>
                                <el-option v-for="(item,index) in sidList"
                                           :key="index"
                                           :label="`${item.id}-${item.levelname}`"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <br>
                        <el-form-item label="层级编码"  class="h-elformWrap-1 classtishis" prop="id" style="position: relative;">
                            <el-input v-model="f.id" placeholder="层级编码自动生成，不需要填写"
                                      :readonly="!cjgly"
                                      onkeyup="this.value=this.value.replace(/[^A-Z0-9]/g,'');" style="width:300px"></el-input>
                            <el-button class="tishis" type="primary" size="mini" style="position: absolute;right: 1.5rem;top: 0;background: #fff;color: #333;border-color: rgba(0,0,0,0);text-align: center;font-weight: bold;">
                                <img src="../../assets/images/tips.png" class="tipsimgs" alt="" style="width: 20px;height: 20px;">
                                <div class="tishiBox">
                                    <p>1.层级编码由大写字母和数字组成；</p>
                                    <p>2.第一级层级编码长度为3位，第二级长度为6位，第三级长度为10位，第四级长度为13位</p>
                                    <br>
                                    <p style="margin-top: 5px;">3.二、三、四级层级编码前n位必须是上一级层级编码</p>
                                </div>
                            </el-button>
                        </el-form-item>
                        <el-form-item label="申请附件" class="h-elformWrap-1 miaoshu" >
                            <brupload
                                    :refid="f.id"
                                    reftype="层级编码-附件"
                                    uploadflag
                                    delflag
                                    @filecallback="filecallback"
                            >
                            </brupload>
                        </el-form-item>
                        <br>
                        <el-form-item label="描述" class="h-elformWrap-2 miaoshu" prop="levelname">
                            <el-input v-model="f.levelname" placeholder="" style="width:5.5rem"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="税码" class="h-elformWrap-2 miaoshu" prop="taxcode" v-if="f.fid==1||f.fid==2">
                            <el-input v-model="f.taxcode" placeholder="" style="width:5.5rem"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;padding-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro('f')">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存</el-button>
                    <el-button class="h-btn h-bBtn h-bgblue" @click="submit">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        filters:{
            showlevelblank(v){
                if(v.fid == '1'){
                    return v.id
                }else{
                    return _.repeat('&#8194;', v.fid-0)+""+v.id;
                }
            },
        },
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                instid:null,
                showhistory:false,
                cjgly: false,
                //导入Excel
                uploaddownexcelflag: false,
                dialogFormVisible2:false,
                dialogFormVisible3:false,
                tableData: [],
                sidList: [],
                q: {
                    id: null,
                    fid: null,
                    levelnameLike: null,
                    onelevelin: null,
                    field: null,
                    taxcode: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f: {
                    id:null,
                    fid:null,
                    sid: null,
                    levelname:null,
                    fileids:null,
                    taxcode:null,
                    refer:null,
                },
                l:{
                    pid:null,
                },
                dialogFormVisible1: false,
                //表单
                all: '全部',
                //表格
                multipleSelection: [],
                rules:{
                    fid: [{required: true, message: '请选择所在层级', trigger: 'blur'}],
                    sid: [{required: true, message: '请选择上一级', trigger: 'blur'}],
                    levelname: [{required: true, message: '请输入描述', trigger: 'blur'}],
                    taxcode: [{required: true, message: '请输入税码', trigger: 'blur'}],
                }
            }
        },
        mounted() {
          this.query();
          this.cjgly = this.$store.getters.hasRole('swyl_admin,swyl_cpcjgly');
        },
        methods: {
            showshenpi(v){
                this.instid = v;
                this.showhistory = true;
            },
            filecallback(list){
              this.f.fileids=_.join(_.map(list,"id"),",");
            },
            //提交产品层级
            submit(){
                var flag = true;
                if(this.f.fid == null || this.f.fid == ''){
                    flag = false;
                    this.$message.error("请选择所在层级");
                    return false;
                }else if((this.f.sid == '' || this.f.sid == null) && this.f.fid!=1){
                    flag = false;
                    this.$message.error("请选择上级编码");
                    return false;
                }else if(this.f.levelname == null || this.f.levelname == ''){
                    flag = false;
                    this.$message.error("请输入描述");
                    return false;
                }else if((this.f.fid == 1 || this.f.fid == 2 ) && (this.f.taxcode == null || this.f.taxcode == '')){
                    flag = false;
                    this.$message.error("请输入税码");
                    return false;
                }
                if (flag) {
                    ss.ProductLevel.submit(this.f).then(rd => {
                        this.query();
                        this.dialogFormVisible1 = false;
                        this.dialogFormVisible3 = false;
                        this.$msg.msgs(rd.msg);
                    })
                }
            },
            //暂存产品层级
            zanCun(){
                var flag = true;
                if(this.f.fid == null || this.f.fid == ''){
                    flag = false;
                    this.$message.error("请选择所在层级");
                    return false;
                }else if((this.f.sid == '' || this.f.sid == null) && this.f.fid!=1){
                    flag = false;
                    this.$message.error("请选择上级编码");
                    return false;
                }else if(this.f.levelname == null || this.f.levelname == ''){
                    flag = false;
                    this.$message.error("请输入描述");
                    return false;
                }else if((this.f.fid == 1 || this.f.fid == 2 ) && (this.f.taxcode == null || this.f.taxcode == '')){
                    flag = false;
                    this.$message.error("请输入税码");
                    return false;
                }
                if (flag) {
                    ss.ProductLevel.zanCun(this.f).then(rd => {
                        this.query();
                        this.dialogFormVisible1 = false;
                        this.dialogFormVisible3 = false;
                        this.$msg.msgs(rd.msg);
                    })
                }
            },
            //分页
            query() {
                ss.ProductLevel.query(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.tableData.forEach(elements=>{
                        elements.edittax=1;
                    });
                })
            },
            //编辑改行
            edittaxcode(value,i){
                console.log(value,i)
                value.edittax=0;
                this.$set(this.tableData,i, value);
            },
            //取消编辑该行
            cancelRow(value,i){
                value.edittax=1;
                this.$set(this.tableData,i, value);
            },
            //更新税码
            updatetax(value,i){
                this.$msg.confirm("确认修改税码?",()=>{
                    ss.ProductLevel.updateById(value).then(rd => {
                        this.$msg.alerts("更新税码成功！");
                        value.edittax=1;
                        this.$set(this.tableData,i, value);
                    });
                })
            },
            //编辑改行
            editlevel(value){
                this.l.id = value.id;
                this.l.refer = value.refer;
                ss.ProductLevel.selectByPid(this.l).then(rd => {
                    this.f = rd;
                    this.dialogFormVisible1 = true;
                })
            },
            //新增/修改弹窗
            createdemand() {
                this.f.id = null;
                this.f.sid = null;
                this.f.fid = null;
                this.f.levelname = null;
                this.f.taxcode = null;
                this.dialogFormVisible1 = true;
            },
            //取消新增
            cancelPro(formName) {
                this.dialogFormVisible1 = false;
                this.dialogFormVisible3 = false;
                this.f.id = null;
                this.f.sid = null;
                this.f.fid = null;
                this.f.levelname = null;
                this.f.taxcode = null;
                this.$refs[formName].resetFields();
            },
            //通过级别带出层级信息
            selectByFid() {
                this.f.sid = null;
                ss.ProductLevel.selectByFid(this.f.fid).then(rd => {
                    this.sidList = rd;

                })
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 重置按钮
            resetData() {
                this.q.idLike = null;
                this.q.levelnameLike = null;
                this.q.fid = null;
                this.q.taxcodeLike = null;
            },
            //批量导出
            exportExcel(){
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/productlevel/productLevel/downloadExcel",idlist,"post",'data');
            },
            //删除层级
            deleteIndex(value,i) {
                if(value.refer == 1){
                    this.$msg.confirm("删除操作会同步删除MDM和SAP的数据，确认删除?", () => {
                        ss.ProductLevel.deleteById(value.id).then(rd => {
                            this.$msg.msgs("删除成功！");
                            this.query();
                        });
                    });
                }else{
                    this.$msg.confirm("确认删除该产品层级?", () => {
                        ss.ProductLevel.deleteByIdDraft(value.id).then(rd => {
                            this.$msg.msgs("删除成功！");
                            this.query();
                        });
                    });
                }

            },
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
        },

    }
</script>
<style scoped>
    .tan {
        margin: 30px 0 0 0;
    }
    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }
    .bianju{
        margin:20px;
    }
    .tishis:hover .tishiBox{
        display: block;
    }
    .tishiBox{
        width: 4rem;
        height: 1.3rem;
        border: 1px solid #ccc;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        top: -1.4rem;
        left: -1.7rem;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.3);
        display: none;
        padding: 10px;
        box-sizing: border-box;
    }
    .tishiBox p{
        height: 20px;
        text-align: left;
        color: #E60012;
        font-size: 12px;
        line-height: 20px;
        white-space: normal;
    }
    .tishis .tipsimgs{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
    }
</style>
<style>
    .bianju .h-tableInput .el-input__inner{
        padding: 0.03rem 0.05rem;
    }
    .tan.h-formbLine .el-form-item__label {
        width: 47%;
    }

    .tan.h-formbLine .el-form-item__content {
        width: 53%
    }
    .tan.h-formbLine .h-elformWrap-2{
        width:50%!important;
    }
    .tan.h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .tan.h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .h-formbLine.ljjselectforms .el-form-item__content .el-input__inner{
        height: 0.29rem!important;
    }
</style>
